import "../field/field";
import "../field-bucket/field-bucket";
import { FieldsPane } from "./fields-pane.component";

export * from "./fields-pane.component";
export default FieldsPane;

FieldsPane.define("fields-pane");

declare global {
    interface HTMLElementTagNameMap {
        "fields-pane": FieldsPane;
    }
}
